/* Italian locals for flatpickr */
var Flatpickr = Flatpickr || { l10ns: {} };
Flatpickr.l10ns.it = {};

Flatpickr.l10ns.it.weekdays = {
	shorthand: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
	longhand: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato']
};

Flatpickr.l10ns.it.months = {
	shorthand: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
	longhand: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
};

Flatpickr.l10ns.it.firstDayOfWeek = 1;

Flatpickr.l10ns.it.ordinal = '°';

Flatpickr.l10ns.it.weekAbbreviation = 'Se';

Flatpickr.l10ns.it.scrollTitle = 'Scrolla per aumentare';

Flatpickr.l10ns.it.toggleTitle = 'Clicca per cambiare';

if (typeof module !== "undefined") {
	module.exports = Flatpickr.l10ns;
}


//////////////////
// WEBPACK FOOTER
// ./~/flatpickr/dist/l10n/it.js
// module id = 14
// module chunks = 0